import { render } from "./Indicator.vue?vue&type=template&id=89e7db8e&scoped=true&lang=pug"
import script from "./Indicator.vue?vue&type=script&lang=ts"
export * from "./Indicator.vue?vue&type=script&lang=ts"

import "./Indicator.vue?vue&type=style&index=0&id=89e7db8e&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-89e7db8e"

export default script